/**
 * HUD overlay state machine.
 *
 * UX-аудит 2026-07-07 (docs/analysis/hud-ux-audit-2026-07-07.md): было
 * 4 состояния линейной цепочкой pill→mini→combat→docked — боевой режим
 * в 2-3 кликах от дефолта, mini/docked без собственной ценности. Теперь два:
 *  - 'compact' — статус-полоска актора (бывш. pill);
 *  - 'battle'  — боевая панель (бывш. combat; функционал docked въехал
 *    внутрь раскрывашкой «персонаж»: статы/топ-скиллы/фичи).
 * Legacy-значения из персиста uiPrefs маппятся в pickHudState.
 */
export type HudState = 'compact' | 'battle';

/** Full-sheet overlay active tab */
export type FullSheetTab = 'combat' | 'character' | 'roleplay' | 'builder';

/** Drag position for HUD */
export interface DragPosition {
  x: number;
  y: number;
}

/** HUD state transitions (allowed from → to) */
export const HUD_TRANSITIONS: Record<HudState, HudState[]> = {
  compact: ['battle'],
  battle: ['compact'],
};

/** Character section for scroll-spy (Spec 2) */
export type CharacterSection =
  | 'identity' | 'stats' | 'proficiencies' | 'skills'
  | 'defenses' | 'abilities' | 'spells' | 'inventory' | 'progression'
  | 'resources';

/** Roleplay card type (Spec 3) */
export type RoleplayCardType =
  | 'hero' | 'triada' | 'manners' | 'backstory' | 'goals'
  | 'npc' | 'factions' | 'sessionLog' | 'moments';

/** Edit level for inline-edit (Spec 3) */
export type EditLevel = 'content' | 'params' | 'actions';

/** Builder step (Spec 4) */
export type BuilderStep =
  | 'identity' | 'race' | 'class' | 'stats'
  | 'background' | 'skills' | 'review';

/** Ability score generation method (Spec 4) */
export type AbilityMethod = 'point-buy' | 'standard-array' | 'manual';

/** Drag handle props for child components */
export interface DragHandleProps {
  onPointerDown: (e: React.PointerEvent) => void;
}
